import React, { Fragment } from 'react';
import {
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { array, string, func } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  tabs: array.isRequired,
  onTabChange: func.isRequired,
  type: string.isRequired,
};

const defaultProps = {
  tabs: [],
};

const findActiveTab = (tabs = [], type) => {
  let tab = tabs.find(({ id }) => id === type);

  if (tab === undefined) {
    if (type.search(/subs/) > -1) {
      return tabs.find(({ id }) => id === 'subs');
    }

    tab = tabs.filter(({ tabs = [] }) => tabs.find(({ id }) => id === type));
    return tab[0];
  }

  return tab;
};

const StatisticsTabs = ({ tabs, type, onTabChange, className, toggleSubsAnimation, allTabs }) => {
  const active = findActiveTab(tabs, type) || {};
  const mobileTabs = tabs;
  return (
    <Fragment>
      <Nav className={className} tabs>
        {tabs.map(({ id, title }) => (
          <NavItem key={id}>
            <NavLink
              className="nav-link"
              onClick={(e) => onTabChange(e, id)}
              active={id === active.id}
            >
              {title}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {/* <UncontrolledDropdown className="nav-tabs-collapse">
        <DropdownToggle tag="span" data-toggle="dropdown" className="dropdown-toggle">
          {active ? active.title : ''}
        </DropdownToggle>
        <DropdownMenu>
          {mobileTabs &&
            mobileTabs.map(({ id, title }) => (
              <DropdownItem className="no-padding" key={id} tag="span">
                <NavLink
                  className="nav-link"
                  onClick={(e) => onTabChange(e, id)}
                  active={id === active.id}
                >
                  {title}
                </NavLink>
              </DropdownItem>
            ))}
        </DropdownMenu>
      </UncontrolledDropdown> */}
    </Fragment>
  );
};

StatisticsTabs.propTypes = propTypes;
StatisticsTabs.defaultProps = defaultProps;

export default StatisticsTabs;
